import React, { useState } from "react";
import Alert from "../../../controls/Alert";
import __ from "lodash";
import moment from "moment";

const AirportCostItemValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";
  let id = null;

  if (!error && !record.aircraftType ) {
    error = true;
    errorMessage = "'Aircraft Type' is required";
    id = "aircraftType";
  }
  if (!error && !record.costDescription ) {
    error = true;
    errorMessage = "'Description' is required";
    id = "costDescription";
  }
  if (!error && !record.costCategoryUuid ) {
    error = true;
    errorMessage = "'Cost Category' is required";
    id = "costCategoryUuid";
  }
  if (!error && !record.companyUuid ) {
    error = true;
    errorMessage = "'Supplier' is required for airport costs";
    id = "companyUuid";
  }
  if (!error && (record.active === null || record.active === undefined)) {
    error = true;
    errorMessage = "'Active' indication is required";
    id = "active";
  }

  // if (!error && !record.validFrom ) {
  //   error = true;
  //   errorMessage = `'Valid From' is required`;
  //   id = "validFrom";
  // }
  // if (!error && !record.validTo ) {
  //   error = true;
  //   errorMessage = `'Valid To' is required`;
  //   id = "validTo";
  // }
  const validFrom = moment(record.validFrom);
  const validTo = moment(record.validTo);
  if (!error && validTo.isBefore(validFrom)) {
    error = true;
    errorMessage = `'Valid To' must be after or equal to 'Valid From'`;
    id = "validTo";
  }
  // if (!error && !record.validTimeFrom ) {
  //   error = true;
  //   errorMessage = "'From Hour' is required";
  //   id = "validTimeFrom";
  // }
  // if (!error && !record.validTimeTo ) {
  //   error = true;
  //   errorMessage = "'To Hour' is required";
  //   id = "validTimeTo";
  // }
  if (!error && !record.calculationType ) {
    error = true;
    errorMessage = "'Calculation Type' is required";
    id = "calculationType";
  }

  if (!error && !record.price ) {
    error = true;
    errorMessage = "'Price' is required";
    id = "price";
  }
  if (!error && isNaN(parseFloat(record.price)) ) {
    error = true;
    errorMessage = "Please enter a valid value for 'Price'";
    id = "price";
  }
  if (!error && !record.currencyCode ) {
    error = true;
    errorMessage = "'Currency' is required";
    id = "currencyCode";
  }
  if (!error && (record.minimumQuantity === null || record.minimumQuantity === undefined)) {
    error = true;
    errorMessage = "'Minimum Quantity' is required";
    id = "minimumQuantity";
  }
  if (!error && (record.costAllocationInboundPercentage === null || record.costAllocationInboundPercentage === undefined)) {
    error = true;
    errorMessage = "'Inbound %' is required";
    id = "costAllocationInboundPercentage";
  }
  if (!error && (record.costAllocationOutboundPercentage === null || record.costAllocationOutboundPercentage === undefined)) {
    error = true;
    errorMessage = "'Outbound %' is required";
    id = "costAllocationOutboundPercentage";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );

}

export default AirportCostItemValidator;
